// reactstrap components
import { Container, Row } from "reactstrap";
// core components
import Header from "../../../components/Headers/Header.js";
import LikertRatings from "../../../components/LikertRatings.js";

const Likerts = () => {
  return (
    <>
      <Header
        title="Survey Likerts"
        description="Survey Completion Description"
      />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <LikertRatings />
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Likerts;
